import type { TMessages } from '@/types/TMessages'

export const messages = {
  thanks: 'Спасибо за ваш ответ!',
  action: 'Закрыть',
} as const satisfies TMessages
